import { MountFunctionsMap } from './@types';
import * as FUNCTION from './utils';

const SUCCESS_COLOR = '#417505';
const WARN_COLOR = '#F5A623';
const ERROR_COLOR = '#B30303';
const UNAVAILABLE = '#868686';

const typeDefaultFigurant = '1';
const typeVehicleFigurant = '2';
const typeAnimalFigurant = '3';
const typeFiscal = '4';
const typeChildFigurant = '5';
const typeProfessionalModelFigurant = '8';
const typeAssistentAudience = '9';

const redirectToMissingInfo = {
  1: 'figurante',
  2: '',
  3: '',
  4: 'fiscal',
  5: 'figurante',
  8: 'modelo profissional',
  9: 'auxiliar plateia',
};

export const renderCardTypes: Record<number, string> = {
  1: 'figurante',
  2: 'veiculo',
  3: 'animal',
  4: 'fiscal',
  5: 'menor',
  8: 'figurante',
  9: 'figurante',
};

export const mountDatas: MountFunctionsMap = {
  1: FUNCTION?.mountFigurantData,
  2: FUNCTION?.mountVehicleData,
  3: FUNCTION?.mountAnimalData,
  4: FUNCTION?.mountFiscalData,
  5: FUNCTION?.mountFigurantData,
  8: FUNCTION?.mountFigurantData,
  9: FUNCTION?.mountFigurantData,
};

export {
  SUCCESS_COLOR,
  WARN_COLOR,
  ERROR_COLOR,
  UNAVAILABLE,
  typeDefaultFigurant,
  typeFiscal,
  typeChildFigurant,
  redirectToMissingInfo,
  typeVehicleFigurant,
  typeAnimalFigurant,
  typeProfessionalModelFigurant,
  typeAssistentAudience,
};
